//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import Commons from '../../../../Services/Common/Common';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
import HAM_HAN_01F from '../HAM_HAN_01/HAM_HAN_01F';
import HAM_HAN_02F from '../HAM_HAN_02/HAM_HAN_02F';
import HAM_HAN_GubunPanel from './HAM_HAN_GubunPanel';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ width: '100%', height: '100%', minHeight: 0 }}>
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// 구분 목록(왼쪽) + 탭 내용(오른쪽) 레이아웃
function WithGubun({ props, children }) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        width: '100%',
        height: '100%',
        minHeight: 420,
        alignItems: 'stretch',
      }}
    >
      <Box sx={{ width: 240, flexShrink: 0, height: '100%' }}>
        <HAM_HAN_GubunPanel
          selectedGubunId={props.gubunId}
          onSelect={props.handleGubunSelect}
          validateSelection={props.validateSelection}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, height: '100%' }}>{children}</Box>
    </Box>
  );
}

function HAM_HAN(props) {
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="HazardousMaterials"
          searchYn="Y"
          addYn="Y"
          saveYn="Y"
          printYn={props.value === 1 ? 'Y' : 'N'}
          // multiPrintYn={'Y'}
          // printItem={
          //   props.value === 0
          //     ? props.printItem1
          //     : props.value === 1
          //       ? props.printItem2
          //       : props.value === 2
          //         ? props.printItem3
          //         : ''
          // }
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              props.setFilterClick2(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            }
          }}
          deleteClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setDeleteClick1(true);
            } else if (props.value === 1) {
              props.setDeleteClick2(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            }
          }}
          conditions={[
            ...(props.value !== 1
              ? [
                {
                  type: 'datePicker',
                  title:
                    props.lanInfo.length === 0
                      ? ''
                      : props.lanInfo.find(
                        (f) => f.lanType !== 'MENU' && f.lanId === 'Period'
                      ).LAN_NM, //기간
                  name: Commons.IsMobile()
                    ? props.searchInfo.startDate
                    : '조회일자(시작)',
                  value: dayjs(props.startDate),
                  onChange: (date) => {
                    props.handleStartDateChange(date);

                    if (props.value === 0) {
                      props.setSearchClick1(true);
                    } else if (props.value === 1) {
                      props.setSearchClick2(true);
                    }
                  },
                  currentLocale: 'ko',
                },
                {
                  type: 'datePicker',
                  title:
                    props.lanInfo.length === 0
                      ? ''
                      : props.lanInfo.find(
                        (f) => f.lanType !== 'MENU' && f.lanId === 'Period'
                      ).LAN_NM, //기간
                  name: Commons.IsMobile()
                    ? props.searchInfo.endDate
                    : '조회일자(끝)', //기간
                  value: dayjs(props.endDate),
                  onChange: (date) => {
                    props.handleEndDateChange(date);

                    if (props.value === 0) {
                      props.setSearchClick1(true);
                    } else if (props.value === 1) {
                      props.setSearchClick2(true);
                    }
                  },
                  currentLocale: 'ko',
                },
              ]
              : []),
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                {
                  type: 'combo',
                  name: '회사',
                  items: props.searchInfo.coList,
                  value: props.searchInfo.coCd,
                  onChange: async (e) => {
                    await props.handleCoChange(e);

                    if (props.value === 0) {
                      props.setSearchClick1(true);
                    } else if (props.value === 1) {
                      props.setSearchClick2(true);
                    }
                  },
                },
              ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: props.searchInfo.custList,
              value: props.searchInfo.custCd,
              onChange: async (e) => {
                await props.handleCustChange(e);

                    if (props.value === 0) {
                      props.setSearchClick1(true);
                    } else if (props.value === 1) {
                      props.setSearchClick2(true);
                    }
              },
            },
          ]}
          placeholder="파일명"
          grids={
            <React.Fragment>
              <Box sx={{ mb: 1 }}>
                <Tabs
                  value={props.value}
                  onChange={props.handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="물질안전보건자료(MSDS)"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="MSDS 관리대장"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <WithGubun props={props}>
                <HAM_HAN_01F
                  gubunId={props.gubunId}
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  copyClick1={props.copyClick1}
                  setCopyClick1={props.setCopyClick1}
                  validateSelection={props.validateSelection}
                />
                </WithGubun>
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <WithGubun props={props}>
                <HAM_HAN_02F
                  gubunId={props.gubunId}
                  searchRef={props.searchRef}
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  copyClick2={props.copyClick2}
                  setCopyClick2={props.setCopyClick2}
                  validateSelection={props.validateSelection}
                />
                </WithGubun>
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default HAM_HAN;
